"use strict";

var _toConsumableArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlgoliaFilters = exports.findById = exports.updateConstraints = void 0;

var firestore_1 = require("firebase/firestore");

var firebase_1 = require("../config/firebase");

function updateConstraints(constraints, options) {
  var localOrderField = [];
  var localOrderDirection = [];

  var localConstraints = _toConsumableArray(constraints);

  if ((options === null || options === void 0 ? void 0 : options.wheres) && Object.keys(options.wheres).length > 0) {
    var wheres = options.wheres;
    Object.keys(wheres).forEach(function (key) {
      if (!Array.isArray(wheres[key])) {
        switch (typeof wheres[key]) {
          case 'boolean':
          case 'number':
          case 'string':
            {
              localConstraints.push((0, firestore_1.where)(String(key), '==', wheres[key]));
              break;
            }

          case 'object':
            {
              var tmpValue = wheres[key].value;
              var tmpOperator = wheres[key].operator || (Array.isArray(wheres[key].value) ? 'in' : '==');

              if (!['==', 'array-contains-any', 'in', 'not-in'].includes(tmpOperator)) {
                localOrderField.push(key);

                if (['<', '<='].includes(tmpOperator)) {
                  localOrderDirection.push('desc');
                } else {
                  localOrderDirection.push('asc');
                }
              }

              if (['array-contains-any', 'in', 'not-in'].includes(tmpOperator) && !Array.isArray(tmpValue)) {
                tmpValue = [tmpValue];
              }

              localConstraints.push((0, firestore_1.where)(String(key), tmpOperator, tmpValue));
              break;
            }

          default:
        }
      } else {
        switch (typeof wheres[key][0]) {
          case 'number':
          case 'string':
            {
              localConstraints.push((0, firestore_1.where)(String(key), 'in', wheres[key]));
              break;
            }

          case 'object':
            {
              wheres[key].forEach(function (objectWhere) {
                var tmpValue = objectWhere.value;
                var tmpOperator = objectWhere.operator || (Array.isArray(objectWhere.value) ? 'in' : '==');

                if (!['==', 'array-contains-any', 'in', 'not-in'].includes(objectWhere.operator)) {
                  localOrderField.push(key);

                  if (['<', '<='].includes(tmpOperator)) {
                    localOrderDirection.push('desc');
                  } else {
                    localOrderDirection.push('asc');
                  }
                }

                if (['array-contains-any', 'in', 'not-in'].includes(tmpOperator) && !Array.isArray(tmpValue)) {
                  tmpValue = [tmpValue];
                }

                localConstraints.push((0, firestore_1.where)(String(key), tmpOperator, tmpValue));
              });
            }
        }
      }
    });
  }

  localOrderField.forEach(function (order, idx) {
    localConstraints.push((0, firestore_1.orderBy)(order, localOrderDirection[idx]));
  });

  if (options === null || options === void 0 ? void 0 : options.orderField) {
    localConstraints.push((0, firestore_1.orderBy)(options.orderField, (options === null || options === void 0 ? void 0 : options.orderDirection) || 'asc'));
  }

  return localConstraints;
}

exports.updateConstraints = updateConstraints;

var findById = function findById(collectionName, id, options) {
  return (0, firestore_1.getDoc)((0, firestore_1.doc)(firebase_1.firestore, collectionName, id)).then(function (documentSnapshot) {
    if (!documentSnapshot.exists()) {
      throw new Error("Le document de la collection ".concat(collectionName, " qui a pour id \"").concat(id, "\" n'existe pas"));
    }

    if ((options === null || options === void 0 ? void 0 : options.espaceId) && documentSnapshot.get('boutique') !== options.espaceId) {
      throw new Error("Ce document n'appartient pas à cette boutique");
    }

    if (documentSnapshot.get('deleted')) {
      throw new Error('Ce document a été supprimé');
    }

    return documentSnapshot;
  });
};

exports.findById = findById;

var getAlgoliaFilters = function getAlgoliaFilters(wheres) {
  var filters = [];

  if (wheres && Object.keys(wheres).length > 0) {
    Object.keys(wheres).forEach(function (key) {
      var operator = ':';
      var value = wheres[key];

      if (undefined !== value) {
        if (Array.isArray(wheres[key])) {
          wheres[key].forEach(function (filtre) {
            if ('boolean' === typeof filtre.value) {
              value = Boolean(filtre.value);
              operator = ':';
            }

            if (Number.isInteger(filtre.value)) {
              value = filtre.value;

              switch (filtre.operator) {
                case '<':
                  operator = '<';
                  break;

                case '>':
                  operator = '>';
                  break;

                case '==':
                default:
                  operator = '=';
              }
            }

            filters.push("".concat(key).concat(operator).concat(value));
          });
        } else if ('object' === typeof wheres[key]) {
          var filtre = wheres[key];

          switch (typeof filtre.value) {
            case 'boolean':
              {
                value = Boolean(filtre.value);
                operator = ':';
                filters.push("".concat(key).concat(operator).concat(value));
                break;
              }

            case 'number':
              {
                if (Number.isInteger(filtre.value)) {
                  value = filtre.value;

                  switch (filtre.operator) {
                    case '<':
                      operator = '<';
                      break;

                    case '>':
                      operator = '>';
                      break;

                    case '==':
                    default:
                      operator = '=';
                  }
                }

                filters.push("".concat(key).concat(operator).concat(value));
                break;
              }

            case 'object':
              {
                if (Array.isArray(filtre.value)) {
                  var tmp = filtre.value.map(function (v) {
                    return "".concat(key, ":").concat(v);
                  }).join(' OR ');
                  filters.push("(".concat(tmp, ")"));
                }

                break;
              }

            default:
              {
                value = filtre.value;
                operator = ':';
                filters.push("".concat(key).concat(operator).concat(value));
              }
          }
        } else {
          if (Number.isInteger(value)) {
            operator = '=';
          }

          filters.push("".concat(key).concat(operator).concat(value));
        }
      }
    });
  }

  return filters.join(' AND ');
};

exports.getAlgoliaFilters = getAlgoliaFilters;